import { useAccountFlow } from '@shared/hooks';
import { cn } from '@shared/utils';
import { AccountStatus, type AccountResponse } from '@shared/api';
import { AccountVcfcHeader } from './accountVcfcHeader';
import { AccountProgress } from './accountProgress';
import { AccountDetails } from './accountDetails';

interface AccountCardTileVcfcProps {
  className?: string;
  account: AccountResponse;
}

export const AccountCardTileVcfc = (props: AccountCardTileVcfcProps) => {
  const accountFlow = useAccountFlow(props.account.id);

  if (accountFlow?.view === false) return null;
  return (
    <section
      className={cn(
        'flex flex-col rounded-xl bg-white dark:bg-soft-black',
        props.account.status === AccountStatus.Delinquent && 'border border-red',
        props.className,
      )}
    >
      <AccountVcfcHeader account={props.account} viewAvailableBalance={accountFlow?.viewAvailableBalance} />
      <hr className='mx-5 my-3 text-gray-black' />
      <AccountProgress className='px-5 py-4' account={props.account} />
      <AccountDetails
        className={cn(
          'rounded-lg p-4',
          props.account.status === AccountStatus.Active && 'bg-primary',
          ([AccountStatus.Blocked, AccountStatus.Delinquent] as AccountStatus[]).includes(props.account.status) && 'bg-red',
          ([AccountStatus.Closed, AccountStatus.Dormant] as AccountStatus[]).includes(props.account.status) && 'bg-light/70',
        )}
        account={props.account}
        isVcfc
      />
    </section>
  );
};
